import { z } from "zod";

import { machineBaseSchema } from "./machine-base";
import { machineTrackSchema } from "./utils/machine-track";

export const machineWithTracksSchema = machineBaseSchema.extend({
	tracks: z.array(machineTrackSchema),
});
